import { useEffect } from 'react';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { setEditorContent } from '../RichTextEditor.utils';

const SetContentsPlugin = ({ contents }: { contents: string | undefined }) => {
  const [editor] = useLexicalComposerContext();

  useEffect(() => {
    setEditorContent({ editor, contents });
  }, [contents, editor]);

  return null;
};

export default SetContentsPlugin;
